
import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import DirectoryPage from './pages/DirectoryPage';
import WizardPage from './pages/WizardPage';
import PricingPage from './pages/PricingPage';
import ProfessionalProfilePage from './pages/ProfessionalProfilePage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import ShortlistPage from './pages/ShortlistPage';
import DashboardPage from './pages/DashboardPage';
import ListingFormPage from './pages/ListingFormPage';
import CheckoutSuccessPage from './pages/CheckoutSuccessPage';
import AdminPage from './pages/AdminPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AIAssistant from './components/AIAssistant';

const ScrollToTop = () => {
  const { pathname } = React.useMemo(() => window.location, []);
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App: React.FC = () => {
  return (
    <HashRouter>
      <ScrollToTop />
      <div className="flex flex-col min-h-screen font-sans">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/directory" element={<DirectoryPage />} />
            <Route path="/wizard" element={<WizardPage />} />
            <Route path="/join" element={<PricingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/shortlist" element={<ShortlistPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/listing-setup" element={<ListingFormPage />} />
            <Route path="/checkout-success" element={<CheckoutSuccessPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignupPage />} />
            <Route path="/professional/:id" element={<ProfessionalProfilePage />} />
          </Routes>
        </main>
        <Footer />
        <AIAssistant />
      </div>
    </HashRouter>
  );
};

export default App;
